import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './footer.css';
import { useTranslation } from 'react-i18next';

const Footer = (props) => {
  const { t } = useTranslation();
  return (
    <footer className='footer4-footer7 thq-section-padding'>
      <div className='footer4-max-width thq-section-max-width'>
        <div className='footer4-credits'>
          <div className='thq-divider-horizontal'></div>
          <div className='footer4-row'>
            <div className='footer4-container'>
              <span className='thq-body-small'>© 2025 Visa Slot</span>
            </div>
            <div className='footer4-footer-links'>
              <a
                href='https://www.visa-slot.com/privacy-statement'
                target='_blank'
                rel='noreferrer noopener'
                className='footer4-text2 thq-body-small'
              >
                {props.privacyLink ?? (
                  <Fragment>
                    <span className='footer4-text4'>{t('footer.privacy')}</span>
                  </Fragment>
                )}
              </a>
              <a
                href='https://www.visa-slot.com/terms-of-use'
                target='_blank'
                rel='noreferrer noopener'
                className='footer4-text3 thq-body-small'
              >
                {props.termsLink ?? (
                  <Fragment>
                    <span className='footer4-text5'>{t('footer.terms')}</span>
                  </Fragment>
                )}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  imageAlt: 'image',
  privacyLink: undefined,
  termsLink: undefined,
  imageSrc: '/visa-slot-logo.svg',
};

Footer.propTypes = {
  imageAlt: PropTypes.string,
  privacyLink: PropTypes.element,
  termsLink: PropTypes.element,
  imageSrc: PropTypes.string,
};

export default Footer;
